import React from "react";
import PropTypes from "prop-types";
import styles from "./TooltipWrapper.module.styl";
import Tooltip from "rc-tooltip/es";
import cx from "classnames";

/**
 * @deprecated Use UiKit's <Tooltip /> component.
 */
export default function TooltipWrapper({
    placement,
    trigger,
    align,
    padding,
    overlayContent,
    children,
}) {
    const classes = cx(styles.overlay, styles[`padding_${padding}`]);

    return (
        <Tooltip
            placement={placement}
            trigger={trigger}
            overlay={<div>{overlayContent}</div>}
            overlayClassName={classes}
            align={align}
        >
            {children}
        </Tooltip>
    );
}

TooltipWrapper.propTypes = {
    placement: PropTypes.oneOf([
        "left",
        "right",
        "top",
        "bottom",
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight",
        "leftTop",
        "rightTop",
        "leftBottom",
        "rightBottom",
    ]),
    align: PropTypes.object,
    padding: PropTypes.oneOf(["none", "big"]),
    trigger: PropTypes.oneOfType([
        PropTypes.oneOf(["hover", "click", "focus"]),
        PropTypes.arrayOf(PropTypes.oneOf(["hover", "click", "focus"])),
    ]),
    overlayContent: PropTypes.node,
};

TooltipWrapper.defaultProps = {
    padding: "big",
};
